module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Véronik Avery, Thayer Allyson Gowdy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("VÉRONIK AVERY is the creative director for JCA Yarns. Her designs have appeared in numerous books and magazines, including "), _c('I', [_vm._v("Handknit Holidays")]), _vm._v(" and "), _c('I', [_vm._v("Weekend Knitting")]), _vm._v(" from STC, "), _c('I', [_vm._v("Interweave Knits")]), _vm._v(", "), _c('I', [_vm._v("Woman’s Day")]), _vm._v(", and the webzine Knity.com. Avery lives in Montreal.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/182F5KQ/tc-custom/9781453268124.jpg?1728327163652",
      "alt": "This image is the cover for the book Knitting 24/7"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Knitting 24/7\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Grab the opportunity to knit when you’re commuting, socializing, or just waiting around—with these highly portable projects! ")]), _c('br'), _c('br'), _vm._v(" People who love to knit are determined to find time to practice their craft, despite the many roles they fulfill throughout the day. They knit while traveling or commuting, while waiting for their kids, while socializing. Times like these call for projects that are easily transportable and have stitch patterns that are simple to memorize."), _c('br'), _c('br'), _vm._v(" Véronik Avery has created 30 such projects for "), _c('i', [_vm._v("Knitting 24/7")]), _vm._v(", a collection of stylish clothing and accessories that make use of those “in-between” times when we’re busy, yet our hands are free. Ranging from sweaters, scarves, and shrugs to hats and mitts, the projects represent both what knitters want to wear and what they actually have time to create. The book’s gorgeous color photographs capture knitters in a range of settings—a morning at work, a dinner with friends, a relaxing weekend afternoon—evoking the time of day when each wardrobe item might be worn."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ABRAMS\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0